<div class="bs-stepper" #stepperRef *ngIf="productForm">
  <meeting-control [formGroup]="productForm" [quillStyle]="quillStyle" [hashtags]="hashtags" [amenities]="amenities"
    [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" [previewProduct]="previewProduct"
    [submitMessage]="'상품 수정 완료'" [loadMessage]="'상품 수정 중'" [isLoad]="isLoad"
    [hasUnsavedChanges]="hasUnsavedChanges"
    [lastAutoSaved]="lastAutoSaved"
    [productStatus]="meeting?.status"
    [isMobileVerified]="isMobileVerified"
    [hasReservableTicket]="hasReservableTicket"
    [productId]="meeting?.id ?? null"
    [productReservationHours]="meeting?.reservationHours ?? 0"
    [themeIds]="themeIds" (themeIdsChange)="onThemeIdsChange($event)" [canSelectThemes]="themesLoaded"
    (onVerifyMobileEvent)="openMobileVerification()"
    (onReservableChangeEvent)="refreshReservableTicketState()"
    (onQuillLoadEvent)="quillLoad($event)"
    (onNextEvent)="next()" (onPrevEvent)="prev()" (onLastCheckEvent)="makePreviewProduct()"
    (onChangeAddressEvent)="changeAddress($event)" (onAddEvent)="edit()"
    (onSaveEvent)="saveProduct()"
    (onRequestReviewEvent)="requestReview()"></meeting-control>
</div>

<!-- AI 상품 어드바이저 (베타: 'AI 상품 어드바이저' 유저 그룹 또는 admin 에게만 노출) -->
<!-- host 의 mat-sidenav-content stacking context 를 벗어나도록 ngAfterViewInit 에서 이 앵커를 body 로 이동시킨다 -->
<div class="host-ai-chat-anchor" #aiChatAnchor *ngIf="aiAdvisorEnabled && productContext">
  <ai-chat [productContext]="productContext" (productUpdate)="onAiProductUpdate($event)"></ai-chat>
</div>
